export const AUTHORIZATION_DENIED_EVENT = 'panel:authorization-denied';
export function emitAuthorizationDenied(source) {
    window.dispatchEvent(new CustomEvent(AUTHORIZATION_DENIED_EVENT, {
        detail: { source },
    }));
}
export function authorizationSource(event) {
    if (!(event instanceof CustomEvent))
        return null;
    const source = event.detail?.source;
    return source === 'panel' || source === 'opengater' ? source : null;
}
